import { Box, Heading, Text, List, Button } from '@zillow/constellation';
import React from 'react';

var SuccessState = function SuccessState(_ref) {
  var referenceNumber = _ref.referenceNumber,
    onSubmitAnother = _ref.onSubmitAnother;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      margin: '0 auto',
      marginTop: '$spacing.xl',
      marginBottom: {
        default: '$spacing.xl',
        tablet: '$spacing.2xl'
      },
      padding: {
        default: '$spacing.lg',
        tablet: '$spacing.xl'
      },
      backgroundColor: '$colors.white',
      borderRadius: '$radii.lg',
      boxShadow: '$shadows.lg',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    fontType: "h4",
    textAlign: "center",
    marginBottom: "md",
    fontColor: "textDark",
    fontFamily: "sansSerif"
  }, "Report submitted successfully"), /*#__PURE__*/React.createElement(Text, {
    fontType: "body",
    textAlign: "center",
    marginBottom: "md",
    color: "$colors.textMedium"
  }, "Thank you for helping ensure all consumers have fair access to listings. Our team will review the information provided."), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.gray100',
      borderRadius: '$radii.md',
      padding: '$spacing.md',
      marginBottom: '$spacing.md',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p",
    fontType: "body",
    fontColor: "textDark"
  }, "Your report reference number:"), /*#__PURE__*/React.createElement(Text, {
    fontColor: "brand",
    fontType: "bodyHeading",
    marginTop: "xs"
  }, referenceNumber)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.backgroundBlue',
      borderRadius: '$radii.md',
      padding: '$spacing.md',
      marginBottom: '$spacing.md'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    fontType: "h6",
    marginBottom: "xs",
    fontColor: "textDark",
    fontFamily: "sansSerif",
    placement: "page"
  }, "What happens next?"), /*#__PURE__*/React.createElement(List, {
    appearance: "bullet"
  }, /*#__PURE__*/React.createElement(List.Item, null, "Our team will review your report and the documentation provided to us"), /*#__PURE__*/React.createElement(List.Item, null, "We'll investigate whether the listing is being publicly marketed but not available on MLS, Zillow or other platforms"), /*#__PURE__*/React.createElement(List.Item, null, "If the violation is confirmed, we'll take appropriate action according to our listing access standards"), /*#__PURE__*/React.createElement(List.Item, null, "Together, we're ensuring all consumers have fair access to real estate information"))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    size: "lg",
    onClick: onSubmitAnother
  }, "Submit another report")));
};
var SuccessState$1 = SuccessState;

export { SuccessState$1 as default };
